import React, { Component } from 'react'
import { Row, Col } from 'react-bootstrap'
import i18next from 'i18next'

import styles from './styles/questionnaire.scss'
import illustration from './../assets/images/wopi-wide.png'

export default class QuestionnaireThankYou extends Component {
  componentDidMount() {
    this.props.refreshQuestionnaire()
  }

  render() {
    const { language } = this.props

    return (
      <section className={styles.introductionText} style={{ textAlign: 'center' }}>
        <h1>{i18next.t('welldone', { lng: language, ns: 'questionnaire' })}</h1>

        <Row>
          <Col md={10} mdOffset={1}>
            <p>{i18next.t('wopi_is_done_thank_you', { lng: language, ns: 'questionnaire' })}</p>
          </Col>
        </Row>

        <p>
          <img className={styles.illustration} src={illustration} />
        </p>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/QuestionnaireThankYou.js